export enum ActionType {
  SET_SIGN_IN_REDIRECT = 'SET_SIGN_IN_REDIRECT',
  UPDATE_AUTH_STATE = 'UPDATE_AUTH_STATE',
  SIGNOUT = 'SIGNOUT',
  SHOW_AUTH_MESSAGE = 'SHOW_AUTH_MESSAGE',
  HIDE_AUTH_MESSAGE = 'HIDE_AUTH_MESSAGE',
  SHOW_LOADING = 'SHOW_LOADING',
  HIDE_LOADING = 'HIDE_LOADING',

  SET_CURRENT_COMMUNITY_ID = 'SET_CURRENT_COMMUNITY_ID',
  CLEAR_CURRENT_COMMUNITY_ID = 'CLEAR_CURRENT_COMMUNITY_ID',
  SET_CURRENT_ACCOUNT_ID = 'SET_CURRENT_ACCOUNT_ID',
  CLEAR_CURRENT_ACCOUNT_ID = 'CLEAR_CURRENT_ACCOUNT_ID',

  SET_FOLDER_TREE_ROOT = 'SET_FOLDER_TREE_ROOT',
  SET_FOLDER_TREE_ACTIVE_PATH = 'SET_FOLDER_TREE_ACTIVE_PATH',
}
